import { useCallback, useState } from "react";
import SkillEdit from "../Edits/SkillEdit";
import CmModal from "../Controls/CmModal";

export default function SkillEditModal({
  skillId = 0,
  initialName = "",
  initialDraft = null,
  onClose,
}) {
  const id = Number.parseInt(skillId, 10) || 0;
  const [header, setHeader] = useState(() => ({
    name: (initialDraft?.Name || initialName || "Skill").trim() || "Skill",
    id,
  }));

  // Stable callback so SkillEdit's header sync effect does not thrash.
  const onHeaderChange = useCallback((next) => {
    setHeader((prev) => {
      const name = (next?.name || "").trim() || "Skill";
      const nextId = Number(next?.id) || 0;
      if (prev.name === name && prev.id === nextId) return prev;
      return { name, id: nextId };
    });
  }, []);

  const title = (
    <>
      <span>{header.name || "Skill"}</span>
      <span className="cm-modal-title-id" data-testid="skill-edit-modal-id">
        {header.id > 0 ? `(${header.id})` : "(unsaved)"}
      </span>
    </>
  );

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="wide"
      testId="skill-edit-modal"
    >
      <SkillEdit
        skillId={id}
        initialName={initialName}
        initialDraft={initialDraft}
        onClose={onClose}
        onHeaderChange={onHeaderChange}
      />
    </CmModal>
  );
}
